const BLOCKED_PARTS=new Set(['token','authorization','password','secret','payload','note','photo','blob','email','coordinate','coordinates','lat','lng','latitude','longitude']);

function isBlockedKey(key){
  const parts=String(key||'').toLowerCase().split(/[^a-z0-9]+/).filter(Boolean);
  return parts.some(part=>BLOCKED_PARTS.has(part));
}

function sanitize(properties={}){
  const out={};
  for(const [key,value] of Object.entries(properties||{})){
    if(isBlockedKey(key))continue;
    if(['string','number','boolean'].includes(typeof value))out[key]=typeof value==='string'?value.slice(0,100):value;
  }
  return out;
}

export function createAnalytics({allowedEvents=[],consent=()=>false,sink=()=>{},dimensions={}}={}){
  const allowed=new Set(allowedEvents);
  function track(name,properties={}){
    if(!allowed.has(name))return Object.freeze({accepted:false,reason:'UNKNOWN_EVENT'});
    let hasConsent=false;
    try{hasConsent=!!consent();}catch{return Object.freeze({accepted:false,reason:'CONSENT_CHECK_FAILED'});}
    if(!hasConsent)return Object.freeze({accepted:false,reason:'NO_CONSENT'});
    const event=Object.freeze({name,properties:Object.freeze({...sanitize(dimensions),...sanitize(properties)}),at:new Date().toISOString()});
    try{sink(event);}catch{return Object.freeze({accepted:false,reason:'SINK_FAILED',event});}
    return Object.freeze({accepted:true,event});
  }
  return Object.freeze({track});
}
